import type { TypePolicies } from "@apollo/client"

// The global dataIdFromObject falls back to `Code` for identity, but a
// TypeValueTranslation's Code is the raw type-value code ("1", "Q", "62"),
// shared by dozens of tables — without an explicit key every table's rows
// collapse into one cache entity and the catalog renders duplicate rows.
// ObjectKey ("<TableName>|<Code>") is the unique identity.
export const translationTypePolicies: TypePolicies = {
  TypeValueTranslation: {
    keyFields: ["ObjectKey"],
  },
}
